import { render, staticRenderFns } from "./ToggleEdit.vue?vue&type=template&id=628c7d68&"
import script from "./ToggleEdit.vue?vue&type=script&lang=js&"
export * from "./ToggleEdit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports